import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { ToastService } from '../services/toast.service';
import { UsuarioComponent } from '../usuario/usuario.component';
import { LoadingService } from '../services/loading.service';
declare var bootstrap: any;

interface Usuario {
  id: string;
  nombreCompleto: string;
  usuario: string;
  roles: string[];
  activo: boolean | null;
  contrasena: string;
  contrasenaRepetida: string;
  tipoUsuario: 1;
}

interface UsuarioRequest {
  nombreCompleto: string;
  contrasena: string;
  usuario: string;
  tipoUsuario: number;
  activo: boolean;
  roles: string[];
}

@Component({
  selector: 'app-usuario-modal',
  templateUrl: './usuario-modal.component.html',
  styleUrl: './usuario-modal.component.css',
})
export class UsuarioModalComponent implements OnInit {
  nuevoUsuario: Usuario = this.getNuevoUsuario();
  modoEditar: boolean = false;
  errores: { [key: string]: string } = {};
  mensajeNotificacion: string = '';
  tipoNotificacion: 'success' | 'error' = 'success';
  roles: string[] = [];
  rolesSeleccionados: { [key: string]: boolean } = {};

  constructor(
    private apiSrv: ApiService,
    private usuarioComponent: UsuarioComponent,
    private toastSrv: ToastService,
    private loadingSrv: LoadingService
  ) {}

  ngOnInit(): void {
    this.apiSrv.obtenerTodosLosRoles().subscribe({
      next: (roles: string[]) => {
        this.roles = roles;
      },
      error: (error: any) => {
        this.toastSrv.mostrarNotificacion(
          `Ocurrió un error al obtener los roles: ${error.message}`,
          'error'
        );
      },
    });
  }

  getNuevoUsuario(): Usuario {
    return {
      id: '',
      nombreCompleto: '',
      usuario: '',
      roles: [],
      activo: true,
      contrasena: '',
      contrasenaRepetida: '',
      tipoUsuario: 1,
    };
  }

  abrirModoCreacionUsuario(): void {
    this.modoEditar = false;
    this.nuevoUsuario = this.getNuevoUsuario();
    this.errores = {};
    this.rolesSeleccionados = {};
    this.mostrarModal();
  }

  abrirModoEdicionUsuario(usuario: Usuario): void {
    this.modoEditar = true;
    this.nuevoUsuario = { ...usuario, contrasena: '', contrasenaRepetida: '' };
    this.rolesSeleccionados = {};
    usuario.roles.forEach((rol) => {
      const rolSinPrefijo = rol.replace('ROLE_', '');
      this.rolesSeleccionados[rolSinPrefijo] = true;
    });
    this.mostrarModal();
  }

  mostrarModal(): void {
    const modalElement = document.getElementById('nuevoUsuarioModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();

      modalElement.addEventListener(
        'hidden.bs.modal',
        () => {
          this.cerrarModal();
        },
        { once: true }
      );
    }
  }

  agregarUsuario(): void {
    this.loadingSrv.setLoading(true);
    if (this.validarNuevoUsuario()) {
      const usuarioRequest: UsuarioRequest = this.convertirAUsuarioRequest(
        this.nuevoUsuario
      );
      this.apiSrv.crearUsuario(usuarioRequest).subscribe({
        next: (response) => {
          this.loadingSrv.setLoading(false);
          if (response.status === 200) {
            this.nuevoUsuario = this.getNuevoUsuario();
            this.rolesSeleccionados = {};
            this.roles.forEach((rol) => {
              this.rolesSeleccionados[rol] =
                this.nuevoUsuario.roles.includes(rol);
            });
            this.usuarioComponent.recargarTabla();
            this.cerrarModal();
            this.toastSrv.mostrarNotificacion(
              'Usuario guardado correctamente.',
              'success'
            );
          }

          if (response.status === 409) {
            this.toastSrv.mostrarNotificacion(
              'Nombre de usuario existente, elige otro.',
              'error'
            );
          }
        },
        error: (error: any) => {
          this.loadingSrv.setLoading(false);
          this.toastSrv.mostrarNotificacion(
            `Ocurrió un error al guardar el usuario: ${error.error}`,
            'error'
          );
        },
      });
    } else {
      this.loadingSrv.setLoading(false);
    }
  }

  convertirAUsuarioRequest(usuario: Usuario): UsuarioRequest {
    return {
      nombreCompleto: usuario.nombreCompleto,
      contrasena: btoa(usuario.contrasena),
      usuario: usuario.usuario,
      tipoUsuario: 1,
      activo: usuario.activo ?? false,
      roles: usuario.roles,
    };
  }

  validarNuevoUsuario(): boolean {
    this.errores = {};
    if (!this.nuevoUsuario.nombreCompleto) {
      this.errores['nombreCompleto'] = 'El nombre de usuario es requerido.';
    }
    if (!this.nuevoUsuario.usuario) {
      this.errores['usuario'] = 'El usuario es requerido.';
    }
    if (!this.nuevoUsuario.roles.length) {
      this.errores['roles'] = 'Al menos un rol es requerido.';
    }
    if (!this.nuevoUsuario.contrasena) {
      this.errores['contrasena'] = 'La contraseña es requerida.';
    }
    if (!this.nuevoUsuario.contrasenaRepetida) {
      this.errores['contrasenaRepetida'] =
        'La contraseña repetida es requerida.';
    }
    if (this.nuevoUsuario.contrasena !== this.nuevoUsuario.contrasenaRepetida) {
      this.errores['contrasenaRepetida'] = 'Las contraseñas no coinciden.';
    }

    return !Object.keys(this.errores).length;
  }

  validarEditarUsuario(): boolean {
    this.errores = {};
    if (!this.nuevoUsuario.nombreCompleto) {
      this.errores['nombreCompleto'] = 'El nombre de usuario es requerido.';
    }
    if (!this.nuevoUsuario.usuario) {
      this.errores['usuario'] = 'El usuario es requerido.';
    }
    if (!this.nuevoUsuario.roles.length) {
      this.errores['roles'] = 'Al menos un rol es requerido.';
    }

    if (this.nuevoUsuario.contrasena || this.nuevoUsuario.contrasenaRepetida) {
      if (!this.nuevoUsuario.contrasena) {
        this.errores['contrasena'] = 'La contraseña es requerida.';
      }
      if (!this.nuevoUsuario.contrasenaRepetida) {
        this.errores['contrasenaRepetida'] =
          'La contraseña repetida es requerida.';
      }
      if (
        this.nuevoUsuario.contrasena !== this.nuevoUsuario.contrasenaRepetida
      ) {
        this.errores['contrasenaRepetida'] = 'Las contraseñas no coinciden.';
      }
    }

    return !Object.keys(this.errores).length;
  }

  cerrarModal(): void {
    const modalElement = document.getElementById('nuevoUsuarioModal');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }
  }

  actualizarUsuario(): void {
    if (this.validarEditarUsuario()) {
      const usuarioRequest: UsuarioRequest = this.convertirAUsuarioRequest({
        ...this.nuevoUsuario,
        roles: this.nuevoUsuario.roles.map((rol) => `ROLE_${rol}`),
      });
      this.loadingSrv.setLoading(true);
      this.apiSrv
        .actualizarUsuario(btoa(this.nuevoUsuario.id), usuarioRequest)
        .subscribe({
          next: () => {
            this.loadingSrv.setLoading(false);
            this.toastSrv.mostrarNotificacion(
              'Usuario actualizado correctamente.',
              'success'
            );
            this.nuevoUsuario = this.getNuevoUsuario();
            this.cerrarModal();
            this.usuarioComponent.recargarTabla();
          },
          error: (error: any) => {
            this.loadingSrv.setLoading(false);
            this.toastSrv.mostrarNotificacion(
              `Ocurrió un error al actualizar el usuario: ${error.message}`,
              'error'
            );
          },
        });
    }
  }

  eliminarUsuario(idUsuario: string): void {
    this.apiSrv.eliminarUsuario(Number(idUsuario)).subscribe({
      next: (response) => {
        const mensaje = response.body || 'Operación exitosa.';
        if (response.status === 200) {
          this.toastSrv.mostrarNotificacion(mensaje, 'success');
        } else {
          this.toastSrv.mostrarNotificacion(mensaje, 'warning');
        }
        this.cerrarModal();
        this.usuarioComponent.recargarTabla();
      },
      error: (error: any) => {
        this.toastSrv.mostrarNotificacion(
          `Ocurrió un error al eliminar el usuario: ${error.error}`,
          'error'
        );
      },
    });
  }

  onRoleChange(event: Event, rol: string): void {
    this.rolesSeleccionados[rol] = (event.target as HTMLInputElement).checked;
    this.nuevoUsuario.roles = Object.keys(this.rolesSeleccionados).filter(
      (rol) => this.rolesSeleccionados[rol]
    );
  }
}
